export const manifest = {
  screens: {
    scr_765oih: { name: "Home", route: "/" },
  },
}
